// This file is auto-generated by @hey-api/openapi-ts

import type {
  ChangeEmailResponse,
  CompleteRegistrationResponse,
  CreateBookingSessionResponse,
  GetBookableResponse,
  GetBookingPriceSummaryResponse,
  GetBookingSessionResponse,
  GetDevicesResponse,
  GetInvoicesResponse,
  GetOrderHistoryResponse,
  GetPriceBreakdownResponse,
  GetSubscriptionResponse,
  GetUserResponse,
  LinkAppleIdentityResponse,
  ListOrdersResponse,
  UpdatePersonalDataResponse,
} from './types.gen';

const invoiceViewSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt);
  return data;
};

export const getInvoicesResponseTransformer = async (data: any): Promise<GetInvoicesResponse> => {
  if (data) {
    data = data.map((item: any) => invoiceViewSchemaResponseTransformer(item));
  }
  return data;
};

const bookableV2SchemaResponseTransformer = (data: any) => {
  if (data.additionalBookables) {
    data.additionalBookables = data.additionalBookables.map((item: any) => bookableV2SchemaResponseTransformer(item));
  }
  return data;
};

export const getBookableResponseTransformer = async (data: any): Promise<GetBookableResponse> => {
  data = bookableV2SchemaResponseTransformer(data);
  return data;
};

const monthlyPriceSchemaResponseTransformer = (data: any) => {
  data.start = new Date(data.start);
  return data;
};

const priceSchemaResponseTransformer = (data: any) => {
  if (data.monthly) {
    data.monthly = data.monthly.map((item: any) => monthlyPriceSchemaResponseTransformer(item));
  }
  return data;
};

const catalogProductSchemaResponseTransformer = (data: any) => {
  data.price = priceSchemaResponseTransformer(data.price);
  return data;
};

const catalogSchemaResponseTransformer = (data: any) => {
  for (const key of Object.keys(data.products)) {
    data.products[key] = catalogProductSchemaResponseTransformer(data.products[key]);
  }
  return data;
};

const configuratorSessionSchemaResponseTransformer = (data: any) => {
  data.catalog = catalogSchemaResponseTransformer(data.catalog);
  return data;
};

export const createBookingSessionResponseTransformer = async (data: any): Promise<CreateBookingSessionResponse> => {
  data = configuratorSessionSchemaResponseTransformer(data);
  return data;
};

export const getBookingSessionResponseTransformer = async (data: any): Promise<GetBookingSessionResponse> => {
  data = configuratorSessionSchemaResponseTransformer(data);
  return data;
};

const monthlyPriceSummarySchemaResponseTransformer = (data: any) => {
  data.start = new Date(data.start);
  return data;
};

const priceSummarySchemaResponseTransformer = (data: any) => {
  if (data.monthly) {
    data.monthly = data.monthly.map((item: any) => monthlyPriceSummarySchemaResponseTransformer(item));
  }
  return data;
};

export const getBookingPriceSummaryResponseTransformer = async (data: any): Promise<GetBookingPriceSummaryResponse> => {
  data = priceSummarySchemaResponseTransformer(data);
  return data;
};

const activeDeviceSchemaResponseTransformer = (data: any) => {
  data.lastLogin = new Date(data.lastLogin);
  return data;
};

const getActiveDevicesResponseBodySchemaResponseTransformer = (data: any) => {
  if (data.data) {
    data.data = data.data.map((item: any) => activeDeviceSchemaResponseTransformer(item));
  }
  return data;
};

export const getDevicesResponseTransformer = async (data: any): Promise<GetDevicesResponse> => {
  data = getActiveDevicesResponseBodySchemaResponseTransformer(data);
  return data;
};

const shipmentDtoSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt);
  if (data.shippedAt) {
    data.shippedAt = new Date(data.shippedAt);
  }
  return data;
};

const physicalGoodDetailsDtoSchemaResponseTransformer = (data: any) => {
  if (data.returnableUntil) {
    data.returnableUntil = new Date(data.returnableUntil);
  }
  if (data.shipments) {
    data.shipments = data.shipments.map((item: any) => shipmentDtoSchemaResponseTransformer(item));
  }
  if (data.shippedAt) {
    data.shippedAt = new Date(data.shippedAt);
  }
  return data;
};

const subscriptionItemDetailsDtoSchemaResponseTransformer = (data: any) => {
  if (data.end) {
    data.end = new Date(data.end);
  }
  data.start = new Date(data.start);
  return data;
};

const orderItemDtoSchemaResponseTransformer = (data: any) => {
  if (data.physicalGoodDetails) {
    data.physicalGoodDetails = physicalGoodDetailsDtoSchemaResponseTransformer(data.physicalGoodDetails);
  }
  if (data.subscriptionDetails) {
    data.subscriptionDetails = subscriptionItemDetailsDtoSchemaResponseTransformer(data.subscriptionDetails);
  }
  return data;
};

const orderDtoSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt);
  if (data.items) {
    data.items = data.items.map((item: any) => orderItemDtoSchemaResponseTransformer(item));
  }
  return data;
};

const orderHistoryResponseSchemaResponseTransformer = (data: any) => {
  if (data.orders) {
    data.orders = data.orders.map((item: any) => orderDtoSchemaResponseTransformer(item));
  }
  return data;
};

export const getOrderHistoryResponseTransformer = async (data: any): Promise<GetOrderHistoryResponse> => {
  data = orderHistoryResponseSchemaResponseTransformer(data);
  return data;
};

const shipmentSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt);
  if (data.shippedAt) {
    data.shippedAt = new Date(data.shippedAt);
  }
  if (data.stateUpdatedAt) {
    data.stateUpdatedAt = new Date(data.stateUpdatedAt);
  }
  return data;
};

const orderSchemaResponseTransformer = (data: any) => {
  data.createdAt = new Date(data.createdAt);
  if (data.shipments) {
    data.shipments = data.shipments.map((item: any) => shipmentSchemaResponseTransformer(item));
  }
  data.stateUpdatedAt = new Date(data.stateUpdatedAt);
  return data;
};

export const listOrdersResponseTransformer = async (data: any): Promise<ListOrdersResponse> => {
  if (data) {
    data = data.map((item: any) => orderSchemaResponseTransformer(item));
  }
  return data;
};

const subscriptionRecurringChargeSchemaResponseTransformer = (data: any) => {
  data.start = new Date(data.start);
  return data;
};

const subscriptionPriceBreakdownSchemaResponseTransformer = (data: any) => {
  if (data.monthly) {
    data.monthly = data.monthly.map((item: any) => subscriptionRecurringChargeSchemaResponseTransformer(item));
  }
  return data;
};

export const getPriceBreakdownResponseTransformer = async (data: any): Promise<GetPriceBreakdownResponse> => {
  data = subscriptionPriceBreakdownSchemaResponseTransformer(data);
  return data;
};

const userSchemaResponseTransformer = (data: any) => {
  if (data.createdAt) {
    data.createdAt = new Date(data.createdAt);
  }
  if (data.deletedAt) {
    data.deletedAt = new Date(data.deletedAt);
  }
  return data;
};

export const completeRegistrationResponseTransformer = async (data: any): Promise<CompleteRegistrationResponse> => {
  data = userSchemaResponseTransformer(data);
  return data;
};

const discountSubscriptionSchemaResponseTransformer = (data: any) => {
  if (data.end) {
    data.end = new Date(data.end);
  }
  data.start = new Date(data.start);
  return data;
};

const iapSubscriptionSchemaResponseTransformer = (data: any) => {
  data.start = new Date(data.start);
  return data;
};

const modificationSubscriptionSchemaResponseTransformer = (data: any) => {
  if (data.endDate) {
    data.endDate = new Date(data.endDate);
  }
  data.startDate = new Date(data.startDate);
  return data;
};

const optionSubscriptionSchemaResponseTransformer = (data: any) => {
  if (data.end) {
    data.end = new Date(data.end);
  }
  if (data.nextPossibleCancellation) {
    data.nextPossibleCancellation = new Date(data.nextPossibleCancellation);
  }
  data.start = new Date(data.start);
  return data;
};

const productSubscriptionPhaseSchemaResponseTransformer = (data: any) => {
  data.start = new Date(data.start);
  return data;
};

const scheduledSubscriptionCancellationSchemaResponseTransformer = (data: any) => {
  if (data.revocableUntil) {
    data.revocableUntil = new Date(data.revocableUntil);
  }
  data.scheduledFor = new Date(data.scheduledFor);
  if (data.scheduledOn) {
    data.scheduledOn = new Date(data.scheduledOn);
  }
  return data;
};

const subscriptionCancellationInfoSchemaResponseTransformer = (data: any) => {
  if (data.nextPossibleCancellationDate) {
    data.nextPossibleCancellationDate = new Date(data.nextPossibleCancellationDate);
  }
  if (data.scheduledCancellation) {
    data.scheduledCancellation = scheduledSubscriptionCancellationSchemaResponseTransformer(data.scheduledCancellation);
  }
  return data;
};

const userSubscriptionSchemaResponseTransformer = (data: any) => {
  if (data.activeDiscountSubscriptions) {
    data.activeDiscountSubscriptions = data.activeDiscountSubscriptions.map((item: any) =>
      discountSubscriptionSchemaResponseTransformer(item),
    );
  }
  if (data.activeIapSubscriptions) {
    data.activeIapSubscriptions = data.activeIapSubscriptions.map((item: any) => iapSubscriptionSchemaResponseTransformer(item));
  }
  if (data.activeModificationSubscriptions) {
    data.activeModificationSubscriptions = data.activeModificationSubscriptions.map((item: any) =>
      modificationSubscriptionSchemaResponseTransformer(item),
    );
  }
  if (data.activeOptionSubscriptions) {
    data.activeOptionSubscriptions = data.activeOptionSubscriptions.map((item: any) => optionSubscriptionSchemaResponseTransformer(item));
  }
  data.activeProductSubscription = productSubscriptionPhaseSchemaResponseTransformer(data.activeProductSubscription);
  data.cancellationInfo = subscriptionCancellationInfoSchemaResponseTransformer(data.cancellationInfo);
  if (data.discountSubscriptions) {
    data.discountSubscriptions = data.discountSubscriptions.map((item: any) => discountSubscriptionSchemaResponseTransformer(item));
  }
  if (data.modificationSubscriptions) {
    data.modificationSubscriptions = data.modificationSubscriptions.map((item: any) =>
      modificationSubscriptionSchemaResponseTransformer(item),
    );
  }
  if (data.optionSubscriptions) {
    data.optionSubscriptions = data.optionSubscriptions.map((item: any) => optionSubscriptionSchemaResponseTransformer(item));
  }
  if (data.productSubscriptions) {
    data.productSubscriptions = data.productSubscriptions.map((item: any) => productSubscriptionPhaseSchemaResponseTransformer(item));
  }
  return data;
};

export const getSubscriptionResponseTransformer = async (data: any): Promise<GetSubscriptionResponse> => {
  data = userSubscriptionSchemaResponseTransformer(data);
  return data;
};

export const getUserResponseTransformer = async (data: any): Promise<GetUserResponse> => {
  data = userSchemaResponseTransformer(data);
  return data;
};

export const linkAppleIdentityResponseTransformer = async (data: any): Promise<LinkAppleIdentityResponse> => {
  data = userSchemaResponseTransformer(data);
  return data;
};

export const changeEmailResponseTransformer = async (data: any): Promise<ChangeEmailResponse> => {
  data = userSchemaResponseTransformer(data);
  return data;
};

export const updatePersonalDataResponseTransformer = async (data: any): Promise<UpdatePersonalDataResponse> => {
  data = userSchemaResponseTransformer(data);
  return data;
};
